export function frontDoorLinks(
  links: readonly {
    title: string;
    href: string;
  }[],
): {
  label: string;
  href: string;
}[] {
  return [
    { title: "Agent guide (play.md)", label: "Agent guide" },
    { title: "Source", label: "Source" },
    { title: "README", label: "README" },
  ].flatMap(({ title, label }) => {
    const link = links.find(
      (item) => item.title.replace(/\s*↗\s*$/, "") === title,
    );
    return link ? [{ label, href: link.href }] : [];
  });
}
